import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'

const endpoints = (baseURL => {
  return {
    getAnagraphicData: () => `${baseURL}/api/adm/anagraphic`
  }
})(process.env.BEANAGRAPHIC_URL)

export const beAnagraphicGetAnagraphicData = () => {
  const url = endpoints.getAnagraphicData()
  return apiWrapper({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(extractApiData)
}
